import React, { FC } from 'react'

import { map } from 'lodash'

import { Text } from '@interco/inter-ui/components/Text'
import { uuid } from '@interco/inter-ui'

import { Report } from '../../../types/YourPersonalData.types'
import { ReportCard } from '../report-card/ReportCard'
import { ReportsMonthSectionContainer, ReportCardsContainer } from './styles'

type ReportsMonthSectionProps = {
  monthName: string
  reportByMonth: Report[]
}

export const ReportsMonthSection: FC<ReportsMonthSectionProps> = ({ monthName, reportByMonth }) => (
  <ReportsMonthSectionContainer key={uuid()}>
    <Text variant="body-3" color="typography" colorWeight={500} bold>
      {monthName}
    </Text>
    <ReportCardsContainer>
      {map(reportByMonth, (report) => (
        <ReportCard key={uuid()} {...report} />
      ))}
    </ReportCardsContainer>
  </ReportsMonthSectionContainer>
)
